<template>
  <div class="p-3 w-100">
    <div class="sync-data-layout">
      <div class="sync-type-menu">
        <div v-for="(syncType, index) in visibleSyncTypes" :key="index" class="sync-type-menu__item">
          <el-tag
            @click="handleSelectSyncType(syncType.key)"
            v-bind:style="syncType.key == activeSyncType ? activeMenuStyle : normalMenuStyle"
            effect="dark"
            style="height:40px "
            class="pointer text-center pt-1 px-3 fw-bold font-size-16 sync-type-menu__tag">
            {{ syncType.displayName }}
          </el-tag>
        </div>
      </div>

      <div v-if="activeSyncConfig" class="sync-data-content">
        <CloudSetting v-if="activeSyncConfig.key === 'cloud'" />
        <SwContactSetting v-else-if="activeSyncConfig.key === 'swContact'" />
        <div v-else class="sync-data-list">
          <div class="d-flex justify-content-between align-items-center sync-data-list__header">
            <div class="sync-data-list__title fw-bold">Danh sách đồng bộ</div>
            <el-input
              v-model="searchAccountText"
              clearable
              size="small"
              prefix-icon="el-icon-search"
              placeholder="Tìm theo tên, biệt danh hoặc số điện thoại"
              class="sync-data-list__search" />
          </div>
          <el-table
            v-loading="loadingSyncItems"
            :data="getSyncItems(activeSyncConfig.key)"
            row-key="accountId"
            border
            size="small"
            class="sync-data-table"
            empty-text="Không có dữ liệu">
            <el-table-column label="Tài khoản" min-width="180">
              <template slot-scope="scope">
                {{ getAccountNameById(scope.row.accountId) }}
              </template>
            </el-table-column>
            <el-table-column label="Lần cập nhật cuối cùng" min-width="190">
              <template slot-scope="scope">
                {{ formatSyncTime(getLastUpdateTime(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column label="Đồng bộ tiếp theo" min-width="220">
              <template slot-scope="scope">
                {{ getRemainText(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Thao tác" width="150" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  :loading="isSyncing(activeSyncConfig.key, scope.row.accountId)"
                  :disabled="!canSyncRow(scope.row, activeSyncConfig.key)"
                  @click="syncAccount(activeSyncConfig, scope.row)">
                  Đồng bộ
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloudSetting from "@/components/cloud/CloudSetting";
import SwContactSetting from "@/components/swContact/SwContactSetting.vue";

export default {
  name: "SyncData",
  components: {
    CloudSetting,
    SwContactSetting
  },
  props: {
    accounts: { type: Array, default: () => [] }
  },
  data() {
    return {
      activeSyncType: "contact",
      localAccounts: [],
      loadingAccounts: false,
      loadingSyncItems: false,
      syncItemsByType: {
        contact: [],
        group: [],
        oldMessage: [],
        tag: [],
        accountInfo: []
      },
      syncingAccountKeys: [],
      searchAccountText: "",
      syncStatusText: {
        "-1": "Đang đồng bộ",
        0: "Sẵn sàng",
        1: "Đang chờ đồng bộ"
      },
      syncTypes: [
        {
          key: "contact",
          value: "CONTACT",
          displayName: "Danh sách bạn bè",
          title: "Danh sách bạn bè",
          icon: "/assets/icon/ic_user.svg",
          image: "/assets/icon/ic_chat_1.svg",
          endpoint: "/api/sync/contact",
          accountEndpoint: "/api/sync/contact-by-accountId",
          description: "Hệ thống sẽ cập nhật danh sách bạn bè ở Zalo của bạn về phần mềm Salework Zalo."
        },
        {
          key: "group",
          value: "GROUP",
          displayName: "Danh sách nhóm",
          title: "Danh sách nhóm",
          icon: "/assets/icon/ic_users.svg",
          image: "/assets/icon/ic_chat_2.svg",
          endpoint: "/api/sync/group",
          accountEndpoint: "/api/sync/group-by-accountId",
          description: "Hệ thống sẽ cập nhật danh sách nhóm bạn đã tham gia ở Zalo về phần mềm Salework Zalo."
        },
        {
          key: "oldMessage",
          value: "OLD_MESSAGE",
          displayName: "Tin nhắn cũ",
          title: "Tin nhắn cũ",
          icon: "/assets/icon/ic_mess.svg",
          image: "/assets/icon/ic_chat_3.svg",
          endpoint: "/api/sync/oldMessage",
          accountEndpoint: "/api/sync/oldMessage-by-accountId",
          description: "Hệ thống sẽ cập nhật lại các tin nhắn cũ từ Zalo về phần mềm Salework Zalo."
        },
        {
          key: "tag",
          value: "TAG",
          displayName: "Đồng bộ tag",
          title: "Danh sách tag",
          icon: "/assets/icon/ic_tag_2.svg",
          image: "/assets/icon/ic_chat_3.svg",
          endpoint: "/api/sync/tag",
          accountEndpoint: "/api/sync/tag-by-accountId",
          description: "Hệ thống sẽ cập nhật danh sách tag bạn đã tạo và gắn vào hội thoại của khách hàng ở Zalo về phần mềm Salework Zalo."
        },
        {
          key: "accountInfo",
          value: "ACCOUNT_INFO",
          displayName: "Thông tin tài khoản",
          title: "Thông tin tài khoản",
          icon: "/assets/icon/ic_user.svg",
          image: "/assets/icon/ic_chat_1.svg",
          endpoint: "/api/sync/accountInfo",
          accountEndpoint: "/api/sync/accountInfo-by-accountId",
          description: "Hệ thống sẽ cập nhật thông tin tài khoản Zalo về phần mềm Salework Zalo."
        },
        {
          key: "cloud",
          displayName: "Salework Cloud"
        },
        {
          key: "swContact",
          displayName: "Salework Contact"
        }
      ]
    };
  },
  computed: {
    syncAccounts() {
      return this.accounts.length > 0 ? this.accounts : this.localAccounts;
    },
    activeSyncConfig() {
      return this.visibleSyncTypes.find(item => item.key === this.activeSyncType);
    },
    visibleSyncTypes() {
      return this.syncTypes.filter(item => this.canShowSyncType(item.key));
    },
    activeMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#0A58C0",
        "background-color": this.setTransparencyHex("#0A58C0", 0.08),
        margin: "1px 4px 3px 1px"
      };
    },
    normalMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#696B72",
        "background-color": "transparent",
        margin: "1px 4px 3px 1px"
      };
    }
  },
  watch: {
    accounts: {
      handler() {
        this.fetchSyncItems();
      },
      deep: true
    },
    activeSyncType() {
      this.fetchSyncItems();
    }
  },
  methods: {
    getAccounts() {
      this.loadingAccounts = true;
      return this.$http.get("/api/account/getAll").then(resp => {
        this.localAccounts = resp.data || [];
        return this.fetchSyncItems();
      }).finally(() => {
        this.loadingAccounts = false;
      });
    },
    getActiveSyncType() {
      return this.activeSyncConfig;
    },
    canShowSyncType(syncTypeKey) {
      return syncTypeKey !== "oldMessage" || this.isUserLoginV2();
    },
    handleSelectSyncType(syncTypeKey) {
      if (!this.canShowSyncType(syncTypeKey)) return;
      this.activeSyncType = syncTypeKey;
    },
    isActiveAccount(account) {
      return account && account.status === "ACTIVE";
    },
    getAccountIds() {
      return this.syncAccounts
        .map(account => account.accountId)
        .filter(Boolean);
    },
    getSyncItems(syncTypeKey) {
      return [...(this.syncItemsByType[syncTypeKey] || [])].filter(item => {
        return this.matchAccountSearch(item.accountId);
      }).sort((a, b) => {
        const aCanSync = this.canSyncRow(a, syncTypeKey) ? 1 : 0;
        const bCanSync = this.canSyncRow(b, syncTypeKey) ? 1 : 0;
        if (aCanSync !== bCanSync) return bCanSync - aCanSync;
        return this.getAccountNameById(a.accountId).localeCompare(this.getAccountNameById(b.accountId), "vi");
      });
    },
    fetchSyncItems() {
      const syncType = this.getActiveSyncType();
      const accountIds = this.getAccountIds();

      if (!syncType || !syncType.value || accountIds.length === 0) {
        if (!syncType && this.visibleSyncTypes.length > 0) {
          this.activeSyncType = this.visibleSyncTypes[0].key;
        }
        return Promise.resolve();
      }

      this.loadingSyncItems = true;
      return this.$http.post("/api/sync/findByAccountIdsAndType", {
        accountIds: accountIds,
        syncType: syncType.value
      }).then(resp => {
        this.$set(this.syncItemsByType, syncType.key, resp.data || []);
      }).finally(() => {
        this.loadingSyncItems = false;
      });
    },
    getAccountNameById(accountId) {
      const account = this.syncAccounts.find(item => item.accountId === accountId);
      return account ? this.getAccountName(account) : accountId;
    },
    getAccountById(accountId) {
      return this.syncAccounts.find(item => item.accountId === accountId);
    },
    normalizeSearchText(value) {
      return (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d");
    },
    normalizePhoneText(value) {
      const phone = (value || "").toString().replace(/\D/g, "");
      if (phone.startsWith("840")) return "0" + phone.substring(3);
      if (phone.startsWith("84")) return "0" + phone.substring(2);
      return phone;
    },
    matchAccountSearch(accountId) {
      const keyword = this.normalizeSearchText(this.searchAccountText);
      const phoneKeyword = this.normalizePhoneText(this.searchAccountText);
      if (!keyword) return true;

      const account = this.getAccountById(accountId);
      if (!account) {
        return this.normalizeSearchText(accountId).includes(keyword);
      }

      return [
        this.getAccountName(account),
        account.swName,
        account.phoneNumber,
        account.phone
      ].some(value => {
        const normalizedValue = this.normalizeSearchText(value);
        const normalizedPhone = this.normalizePhoneText(value);
        return normalizedValue.includes(keyword)
          || (phoneKeyword && normalizedPhone.includes(phoneKeyword));
      });
    },
    getDisplayValue(value) {
      return value || "--";
    },
    getSyncStatus(item) {
      if (Object.prototype.hasOwnProperty.call(item, "status")) return item.status;
      if (Object.prototype.hasOwnProperty.call(item, "state")) return item.state;
      if (Object.prototype.hasOwnProperty.call(item, "syncStatus")) return item.syncStatus;
      return null;
    },
    getSyncStatusText(item) {
      const status = this.getSyncStatus(item);
      if (status === null || status === undefined || status === "") return "--";
      return this.syncStatusText[status] || status;
    },
    formatSyncTime(value) {
      if (!value) return "--";
      return this.formatDateTimeShort ? this.formatDateTimeShort(value) : value;
    },
    getLastUpdateTime(item) {
      return item.finishAt || item.updateAt || item.updatedAt || item.lastSyncAt || item.createAt;
    },
    getTimeValue(value) {
      if (!value) return null;
      if (typeof value === "number") return value;

      const parsed = Date.parse(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    getRemainText(item) {
      if (!this.isActiveAccount(this.getAccountById(item.accountId))) {
        return "Tài khoản không hoạt động";
      }
      if (this.activeSyncType === "oldMessage" && !this.isUserLoginV2()) {
        return "Chỉ đồng bộ tin nhắn với tài khoản loginV2";
      }
      if (item.remainText) {
        return item.remainText;
      }

      const finishTime = this.getTimeValue(item.finishAt);
      const intervalMinute = Number(item.intervalMinute);

      if (!finishTime || !intervalMinute) {
        return "Sẵn sàng đồng bộ";
      }

      const nextSyncTime = finishTime + intervalMinute * 60 * 1000;
      const remainMs = nextSyncTime - Date.now();

      if (remainMs <= 0) {
        return "Sẵn sàng đồng bộ";
      }

      const totalMinutes = Math.ceil(remainMs / (60 * 1000));
      const days = Math.floor(totalMinutes / (24 * 60));
      const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
      const minutes = totalMinutes % 60;
      const parts = [];

      if (days > 0) parts.push(days + " ngày");
      if (hours > 0) parts.push(hours + " giờ");
      if (minutes > 0 || parts.length === 0) parts.push(minutes + " phút");

      return "Còn " + parts.join(" ") + " (" + this.formatSyncTime(nextSyncTime) + ")";
    },
    isUserLoginV2() {
      const loginV2 = this.app && this.app.user ? this.app.user.loginV2 : false;
      return loginV2 === true || loginV2 === 1 || loginV2 === "1" || loginV2 === "true";
    },
    canSyncRow(item, syncTypeKey = this.activeSyncType) {
      if (!this.isActiveAccount(this.getAccountById(item.accountId))) {
        return false;
      }
      if (syncTypeKey === "oldMessage" && !this.isUserLoginV2()) {
        return false;
      }
      const syncStatus = Number(this.getSyncStatus(item));
      if (syncStatus === -1 || syncStatus === 1) return false;
      const finishTime = this.getTimeValue(item.finishAt);
      const intervalMinute = Number(item.intervalMinute);
      if (!finishTime || !intervalMinute) return true;
      return finishTime + intervalMinute * 60 * 1000 <= Date.now();
    },
    getSyncingKey(syncTypeKey, accountId) {
      return syncTypeKey + ":" + accountId;
    },
    isSyncing(syncTypeKey, accountId) {
      return this.syncingAccountKeys.includes(this.getSyncingKey(syncTypeKey, accountId));
    },
    syncAccount(syncType, item) {
      if (!this.canSyncRow(item, syncType.key)) return;
      const syncingKey = this.getSyncingKey(syncType.key, item.accountId);
      if (this.syncingAccountKeys.includes(syncingKey)) return;
      this.syncingAccountKeys.push(syncingKey);
      if (syncType.key === "contact") {
        localStorage.removeItem("contact");
        localStorage.removeItem("alias");
      }
      this.$http.post("/api/sync/request-sync", {
        accountIds: [item.accountId],
        syncType: syncType.value
      }).then(() => {
        this.alert("success", syncType.displayName + " thành công, quá trình này có thể diễn ra trong ít phút.");
        return this.fetchSyncItems();
      }).finally(() => {
        this.syncingAccountKeys = this.syncingAccountKeys.filter(key => key !== syncingKey);
      });
    }
  },
  created() {
    if (this.accounts.length === 0) {
      this.getAccounts();
    }
  },
  mounted() {
    if (!this.isAdminUser()) {
      this.$router.push("/conversation");
    }
  }
};
</script>

<style scoped>
.sync-data-layout {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  width: 100%;
}

.sync-data-content {
  flex: 1;
  min-width: 0;
}

.sync-data-list {
  background: #ffffff;
  border: 1px solid #dcdfe9;
  border-radius: 8px;
  padding: 12px;
}

.sync-data-list__title {
  color: #202125;
  font-size: 16px;
}

.sync-data-list__header {
  gap: 12px;
  margin-bottom: 12px;
}

.sync-data-list__search {
  max-width: 360px;
}

::v-deep .sync-data-table {
  font-size: 14px;
}

::v-deep .sync-data-table th {
  color: #696b72;
  font-size: 14px;
  font-weight: 700;
}

.sync-type-menu {
  border-right: 1px solid #e5e8ef;
  flex: 0 0 220px;
  padding-right: 12px;
  position: sticky;
  top: 12px;
}

.sync-type-menu__item {
  margin-bottom: 8px;
}

.sync-type-menu__tag {
  align-items: center;
  display: flex;
  font-size: 16px;
  justify-content: flex-start;
  margin: 0 !important;
  width: 100%;
}

@media (max-width: 768px) {
  .sync-data-layout {
    flex-direction: column;
  }

  .sync-type-menu {
    border-bottom: 1px solid #e5e8ef;
    border-right: 0;
    display: grid;
    flex: none;
    gap: 8px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding-bottom: 12px;
    padding-right: 0;
    position: static;
    width: 100%;
  }

  .sync-type-menu__item {
    margin-bottom: 0;
  }

  .sync-data-content {
    width: 100%;
  }

  .sync-data-list__header {
    align-items: stretch !important;
    flex-direction: column;
  }

  .sync-data-list__search {
    max-width: none;
  }
}
</style>
